const common = {
  createdAt: '创建时间',
  createdBy: '创建人',
  updatedAt: '更新时间',
  updatedBy: '更新人',
  operation: '操作',
  expiredAt:'下次提醒时间',
  yes: '是',
  no: '否',
  all: '全部',
  salesMen: '销售员',
  serviceMen: '服务员',
  user: '用户',
  followers: '跟进人',
  authUsers: "授权用户",
  record: '修改记录',
  details: '修改详情',
  okText: '确认',
  cancelText: '取消',
  startTime: '开始时间',
  endTime: '结束时间',
  open: '开启',
  close: '关闭',
  operationUser: '操作用户',
  mobile: '用户号码',
  organization: '用户组织',
  request: '修改方式',
  changeTime: '修改时间',
  deviceCode: '设备编号',
  deviceName: '设备名称',
  deviceType: '设备类型',
  deviceAddress: '站号地址',
  model: '规格型号',
  customer: '客户',
  customerName: '客户名称',
  protocolCode: '协议编号',
  driverType: '驱动类型',
  intervalTime: '采集间隔(s)',
  dtuCode: '模块编号',
  brand: '品牌',
  installAddress: '安装位置',
  measurement: '度量',
  initialValue: '初始值',
  remark: '备注',
  power: '功率',
  pressure: '压力',
  warrantyPeriod: '质保年限',
  isStationDevice: '是否为站房设备',
  update: '更新',
  nd: '暂无数据',
  none: '无',
  picture: '图片',
  audio: '音频',
  second: '秒',
  minute: '分',
  hour: '小时',
  week: "周",
  sd: '点击确认删除'
}

const messages = {
  cti: '请完善相关时间信息',
  ctr: '请选择正确的时间范围',
  ctrt: '请选择正确的时间范围',
  logFail: '登录失效',
  placeSearchFail: '经查无结果或输入有误(不能直接搜地名或者共有关键词)',
  fetchFail: '请求失败',
  noDevice: '无相关设备信息',
  rri: '替换范围输入有误',
  ctrd: '确认要删除吗？',
  ftd: '删除失败',
  np: '无操作权限',
  company_empty: '请输入公司名称',
  address_empty: '请输入公司地址',
  area_empty: '请输入区域',
  province_empty: '请输入省份',
  city_empty: '请输入城市',
  cta: '确认要添加吗?',
  peu: '请输入用户名',
  pem: '请输入手机号',
  pemp: '请输入11位手机号码',
  peo: '请选择归属组织',
  per: '请选择角色',
  pedc: '请输入设备编号',
  lon: '只能输入大小写字母或数字',
  pedn: '请输入设备名称',
  pedm: '请输入规格型号',
  peda: '请输入站号地址',
  pedt: '请选择设备类型',
  pec: '请选择客户',
  pedd: '请选择驱动类型',
  pedp: '请选择协议编号',
  pedtu: '请输入模块编号',
  error: '错误',
  spk: '请求报错或输入有误(不能直接搜地名或者共有关键词)',
  saASe_empty: '销售员、服务员不能为空',
  ctd: '确认拆除设备吗？',
  ctr: '确认恢复设备吗？',
  cts: '确认修改站房状态吗？',
  confirmD: '点击确认拆除设备',
  confirmR: '点击确认恢复设备',
  confirmS: '点击确认修改站房状态',
  es: '导出成功',
  psi: '请选择采集间隔',
  unspportedAudio: '您的浏览器不支持 audio 标签。',
  selectServiceType: '请选择服务类型',
  selectDevice: '请选择设备',
  enterServicehours: '请输入服务工时',
  enterServiceContent: '请输入服务内容',
  enterServiceMan: '请输入服务员',
  enterhoursNumber: '服务工时及运行累时只能输入数字',
  lessThan500MB: '文件必须小于500MB',
  lessThan1MB: '图片必须小于1MB',
  rightFile: '只能上传正确格式的文件',
  ctrp: '确认删除图片吗?',
  hint: '提示',
  rs: '删除成功',
  cr: '已取消删除',
  ctraudio: '确认删除音频吗',
  enterModel: '请输入设备型号',
  success: '成功',
  fail: '失败',
  orderNo: '请输入订单号',
  orderType: '请选择订单类型',
  orderScore: '请输入订单积分',
  finishTime: '请选择预计完成时间',
  customerId: '请选择客户',
  deviceId: '请选择设备',
  ctrwi: '确认删除故障信息吗?',
  ctrwic: '点击确认删除故障信息',
  peymn: '请输入手机号码',
  peyp: '请输入密码',
  pev: '请输入验证码',
  turac: '该用户需要验证码验证',
  wp: '密码错误',
  eon: '请输入组织名称',
  ecc: '请输入客户端编码',
  ecn: '请输入客户端名称',
  YSBID: '请输入ID',
  YSBName: '请输入姓名',
  JDO: '请选择金蝶组织',
  JDD: '请选择金蝶部门',
  moreThanOneMonth: '日期范围不能超过一个月'
}

const placeholder = {
  mobile: '请输入联系方式',
  contactPerson: '请输入联络人',
  searchCustomer: '搜索客户',
  searchProtocolCode: '搜索协议',
  points: '请选择参数',
  device: '请选择设备',
  timeRange: '请选择时间范围',
  templateName: '请输入模板名称',
  t: '允许查询的设备类型'
}

const buttons = {
  fullscreen: '全屏',
  search: '查询',
  add: '新增',
  edit: '编辑',
  delete: '删除',
  logout: '退出登录',
  save: '保存',
  goBack: '返回',
  export: '导出',
  exportHistory: '历史数据导出',
  uploadPic: '上传图片',
  uploadAud: '上传音频',
  refresh: '刷新',
  reset: '重置',
  comparisonOfGasElectricityRatio: '气电比对比',
  time: '设备分时对比',
  bind: '绑定',
  history: '删除历史数据',
  fold: '收起',
  expand: '展开',
  zoomIn: '放大',
  hyperlink: "超链接",
  addParam: "新增参数"
}

const login = {
  title: '登录',
  logIn: '登录',
  username: '账号',
  password: '密码',
  r: '记住密码',
  button: '登录',
  getCaptcha: '获取验证码',
  forgetPassword: '忘记密码',
  resetPassword: '重置密码',
  getLater: '秒后可再次',
  returnLogin: '返回登录'
}

const overview = {
  service: '服务',
  monitor: '监控',
  list: '预警',
  bigData: "大数据监测",
  serviceContent: {
    dispatchD: '本日派工单',
    serviceD: '本日服务单',
    serviceM: '近30天服务单',
    dispatchM: '近30天派工单',
    statistics: '近7天服务单统计',
    volume: '近30天服务量Top10',
    fault: '近半年预警趋势',
    maintain: '维保类型占比',
    dispatch: '派工单'
  },
  monitorContent: {
    title: '德曼大数据监测中心',
    status: '运行状态',
    Analysis: '设备分析',
    Distribution: '设备分布Top10',
    open: '开机数',
    loadRate: '平均负载率',
    temp: '平均温度',
    emission: '累计减排效果',
    electricityConsumption: '总用电量',
    CO2: 'CO₂减排量',
    trend: '各年减排趋势',
    year: '本年减排详情',
    ye: '本年用电量(kW·h)',
    yc: '本年碳减排量(t)',
    me: '本月用电量(kW·h)',
    mc: '本月碳减排量(t)',
    de: '本日用电量(kW·h)',
    dc: '本日碳减排量(t)',
    city: '城市CO₂减排贡献(单位:万吨)',
    device: '设备数',
    agent: '代理商',
    user: '设备用户'
  },
  listContent: {
    title: '德曼提前预警一览表',
    setting: '配置',
    pageGap: '换页间隔',
    rows: '每页行数',
    total: '总行数',
    extra: '输入-1查询所有数据',
    replaceWord: '客户名称替换词',
    replaceRange: '客户名称替换范围',
    type: '显示预警类型',
    fontSize: '字体大小'
  },
  bigDataContent: {
    title: "德曼大数据监测中心",
    sleep: "待机",
    prepare: "备机",
    powerOff: "未上电",
    powerOnPercent: "开机率",
    loadRate: "平均负载率",
    temp: "平均温度",
    monitoringDevice: "监测设备",
    device: "设备数",
    user: "设备用户",
    emissionReduction: "累计减排效果",
    CO2: 'CO₂减排量',
    warning: "客户提前预警一览表",
    year: "本年减排详情",
    theYear: "本年",
    month: "本月",
    day: "今日",
    C: "碳减排量",
    trend: "历年减排趋势"
  }
}

const user = {
  title: '用户列表',
  OpenCheck: '开启校验',
  columns: {
    name: '用户名',
    mobile: '手机号',
    organization: '组织',
    role: '角色',
    requiredCaptcha: '是否需要验证码登录',
    enabled: '是否启用',
    loginPlatform: '登录平台'
  },
  modal: {
    PC: 'PC端',
    mobile: '移动端',
    organization: '归属组织',
    resetPassword: '重置密码',
    authorities: '权限设置',
    deviceModifyCnt: '设备修改数量限制',
    sac: '远程开关机授权客户',
    appVersion: "App 版本",
    allowedDeviceTypes: "允许查询设备类型"
  },
  bashPut: "批量更新 APP 版本",
  active: "用户活跃分析",
  eav: "请输入 App 版本",
  newApp: "新 APP 版本"
}

const region = {
  title: '省市区管理',
  sc: '请搜索国家',
  code: '行政区划代码'
}

const customer = {
  title: '客户列表',
  company: '公司名称',
  address: '公司地址',
  realName: '用户姓名',
  organizationName: '用户组织',
  addTitle: '新增客户',
  editTitle: '编辑客户',
  mobile: '联系方式',
  contactPerson: '联络人',
  area: '区域',
  province: '省份',
  city: '城市',
  country: '国家',
  country_empty: '请选择国家',
  deviceBeingUsed: '在用设备',
  maintainSmsEnabled: '保养短信通知',
  inspectionSmsEnabled: '巡检短信通知',
  errorSmsEnabled: '故障短信通知',
  add: '添加',
  addDevice: '添加设备',
  ssqSetting: '省市区设置',
  searchCountry: "搜索国家",
  searchProvince: '搜索省份',
  searchCity: '搜索城市',
  searchArea: '搜索区域',
  ssqFormModalTitle: '省市区',
  parent: '父级',
  administrativeLevel: '行政级别'
}

const device = {
  title: '设备列表',
  code: '整机编号',
  status: '运行状态',
  organization: '归属组织',
  businessType: '业务类型',
  countDown: '倒计时',
  dtuStatus: '模块状态',
  rsm: '是否重启模块？',
  enable: '拆除状态',
  yes: '已拆除',
  no: '正常',
  history: '历史数据',
  details: '设备详情',
  monitor: '实时监测',
  map: '设备定位',
  bindingDevice: '绑定设备',
  deviceSelect: '设备选择',
  writeValue: '写入参数',
  switchDevice: '远程开关机',
  moduleChanged: '修改模块',
  deviceInfo: '设备信息',
  deviceConnect: '设备控制',
  pointCode: '协议数据点编码',
  value: '写入值',
  np: '暂无定位',
  readOnlyParameters: '只读参数',
  writableParameters: '可写参数',
  errorParameters: '错误参数',
  dataUpdateTime: '上次更新时间',
  analyze: '解析',
  write: '写入',
  failure: '故障',
  sOrganization: '服务组织',
  runTime: '运行时间',
  maintainTime: '保养时间',
  maintainSettingTime: '保养设定时间',
  powerOnTime: '设备开机时间',
  detailsInfo: '详细信息',
  count: '采集率统计',
  analysis: '数据分析',
  acquisitionInterval: '采集间隔：',
  expection: '预期数据量：',
  real: '实际数据量：',
  rate: '数据采集率：',
  setParameters: '设定参数',
  setRange: '设定范围：',
  setValue: '设定值：',
  errorName: '故障名称',
  transducerCode: '变频器型号',
  reasons: '可能原因',
  refreshErrorList: '刷新故障列表',
  deviceSwitch: '设备开关机',
  open: '开机',
  close: '关机',
  continueToListen: '秒后继续监听',
  bitRule: '位解析',
  valueRule: '值解析',
  endMonitor: '监控已结束',
  kl: '继续监听',
  preview: '预览',
  exportP: '按所选参数导出：',
  exportI: '导出时间颗粒度：',
  count: '采集率统计',
  distribution: '数据分布区间统计',
  distributionD: '数据分布区间统计详情',
  addRange: '新增区间',
  analysis: '数据分析',
  countermand: '撤回',
  range: '区间',
  chart: '生成图表',
  removeRange: '删除区间',
  acquisitionInterval: '采集间隔：',
  expection: '预期数据量：',
  real: '实际数据量：',
  rate: '数据采集率：',
  acquisitionDate: '数据采集日期',
  warning: '预警及参数设置',
  warningID: '预警ID',
  warningName: '预警名称',
  warningType: '预警类型',
  warningDimension: '预警维度',
  content: '通知内容',
  mobile: '联系电话',
  deviceType: '设备预警',
  stationType: '站房预警',
  empty: '暂无数据',
  sOrganization: '服务组织',
  runTime: '运行时间',
  maintain: '保养时间',
  mst: '保养设定时间',
  pot: '设备开机时间',
  rsm: '是否重启模块？',
  startTime: '开始时间',
  endTime: '结束时间',
  countDown: '倒计时',
  summary: '汇总',
  confirm: '确认删除',
  selectDate: '请选择日期',
  selectTime: '请选择时间',
  selectRange: '请选择时间范围',
  workingTemperature: '工况温度(℃)',
  workingPressure: '工况压力(Mpa)',
  workingFlow: '工况流量(m³)',
  addTitle: '添加设备',
  Continuous: '数据连续显示：',
  searchTooltip: '数据参数筛选时，基础参数条件必填',
  loadRateCalculation: '计算负载率',
  dateRange: '日期范围',
  unloadingPower: '卸载功率',
  fullLoadPower: '满载功率',
  stanbyPower: '未运行时功率',
  noPoints: '暂无数据点',
  selectPoints: '请选择数据点',
  result: '计算结果',
  electricityMeterAccumulation: '累积用电量',
  maxPower: '最大功率',
  minPower: '最小功率',
  loadingRate: '加载率',
  capacityRate: '负载率',
  description: {
    dateRange: '用于计算的时间范围',
    unloadingPower: '卸载时的功率',
    fullLoadPower: '满载时的功率',
    stanbyPower: '小于未运行时功率的数据不参与计算',
    aPower: '时间范围内平均功率',
    electricityMeterAccumulation: '结束时间-开始时间的电量累计值差',
    maxPower: '选择时间内最大功率值',
    minPower: '选择时间内最小功率值',
    loadingRate: '大于卸载功率的点数/总数',
    capacityRate: '平均功率/满载功率'
  },
  enterUnloadingPower: '请输入卸载功率',
  enterFullLoadPower: '请输入满载功率',
  enterStanbyPower: '请输入停机功率',
  enterNumber: '请输入数字',
  compeleteInfo: '请完善相关信息',
  IndustrialFrequency: '工频',
  variableFrequency: '变频',
  dataCount: '数据总数',
  loadCount: '加载数',
  unloadCount: '卸载数',
  unloadRate: '卸载率',
  ctoc: "确认要开/关机吗？",
  hint: "提示词",
  delay: "延迟时间(s)",
  warningRemind: "预警提醒",
  warningTag: "预警标记",
  axis: "曲线刻度范围设置",
  enterMinAxis: "请输入刻度区间最小值",
  enterMaxAxis: "请输入刻度区间最大值",
  modifyParameter: "禁用参数写入",
  modifyParameter_confirm_title: "确认变更禁用参数写入吗？",
  modifyParameter_confirm_content: "点击确认变更禁用参数写入",
  clearCharts: "清除图表",
  diff: "可选择不同设备参数进行对比"
}

const orders = {
  title: '订单列表',
  add: '添加订单',
  code: '订单编号',
  type: '订单类型',
  state: '订单状态',
  receiver: '接单人',
  cancelState: '作废状态',
  yes: '正常',
  no: '已作废',
  contactPerson: '联系人',
  orderScore: '订单积分',
  finishTime: '预计完成时间',
  rush: '派单',
  ratio: '积分占比',
  helper: '协助人',
  tab: '派单列表',
  cancel: '作废',
  confirmTitle: '确认作废订单吗?',
  clickToConfirm: '点击确认作废订单',
  unreasonableDistribution: '积分占比分配不合理',
  details: '订单详情',
  distance: '订单距离',
  score: '订单评分',
  addHelper: '添加协助人',
  orderInfo: '订单信息',
  ID: '订单id',
  nd: '暂无距离',
  rse: '积分占比分配错误',
  eos: '请输入订单评分'
}

const order_operators = {
  title: '订单人员列表',
  add: '新增订单人员',
  integral: '积分',
  name: '人员名称',
  su: '请选择用户',
  ei: '请输入积分',
  sr: '请选择接单人',
  failedValid: '表单校验不通过',
  editRole: '编辑角色',
  addHelper: '新增协助人',
  editHelper: '编辑协助人',
  editReciver: '编辑接单人'
}

const saleDocument = {
  title: '服务档案',
  add: '添加服务档案',
  addTitle: '新增档案',
  editTitle: '编辑档案',
  serviceType: '服务类型',
  updateman: '修改人',
  serviceTime: '服务时间',
  updateTime: '修改时间',
  createman: '创建人',
  createTime: '创建时间',
  modal: {
    FWLX: '设备归属',
    DM: '德曼设备',
    el: '其它设备',
    sbxh: '设备型号',
    runTime: '运行累时',
    servicehours: '服务工时',
    serviceContent: '服务内容'
  },
  tab: '服务档案'
}

const station = {
  title: '空压站房',
  code: '站房编号',
  name: '站房名称',
  enable: '站房状态',
  enableY: '已拆除',
  enableN: '正常',
  preview: '预览',
  configuration: '组态',
  pm: '参数配置',
  organization: '组织',
  enable: '站房状态',
  preview: '预览',
  statistics: '实时数据',
  dataReport: '数据统计',
  dataReport1: '数据报表',
  warning: '预警设置',
  configuration: '组态',
  data: '数据',
  effectiveState: '能效状态',
  accumulate: '累积能效',
  electricity: '总能耗',
  flow: '总流量',
  electricityL: '实时能耗',
  flowL: '实时流量',
  ratio: '气电比：',
  current: '实时能效',
  socialBenefit: '社会效益',
  es: '累计节能',
  cr: 'CO₂减排量',
  ec7: '近七日能耗监测',
  ratioT: '气电比',
  gas: '用气量',
  electricity: '用电量',
  state: '空压机状态',
  running: '运行',
  standby: '停机',
  offline: '离线',
  error: '故障',
  maintain: '保养',
  pressure: '实时压力',
  pressureC: '实时压力',
  warn: '预警信息',
  ds: '设备选择',
  LLJ: '流量计',
  DB: '电表',
  NXFXY: "能效分析仪",
  key: '关键参数',
  aGas: '平均用气量',
  gas: '流量计累积',
  aPower: '平均功率',
  power: '电表累积',
  aPressure: '平均压力',
  today: '今天',
  yesterday: '昨天',
  ratioTO: "今日单耗分析",
  cf: '瞬时流量',
  cp: '瞬时功率',
  cra: '瞬时气电比',
  dc: '设备对比',
  tld: '最近一天',
  tlw: '最近一周',
  tlm: '最近一月',
  colors: '设备状态颜色分布',
  wf: '工况流量',
  sdt: '温度设备选择',
  spt: '温度参数选择',
  eav: '请输入模拟值',
  analog: '模拟',
  sdp: '压力设备选择',
  spp: '压力参数选择',
  pm: '参数配置',
  addTitle: '站房新增',
  editTitle: '站房编辑',
  flow: '流量',
  gasElectricRatio: '基准气电比',
  interval: '间隔时间',
  charts: '图表',
  gasUnit: '气体单位',
  showElec: "显示电表",
  selectStation: '站房选择',
  ss: '请选择站房',
  esc: '请输入站房编号',
  esn: "请输入站房名称",
  ecn: '请输入客户名称',
  deviceSelect: '设备选择',
  calculationSetting: '设备参数计算配置',
  deleteConfiguration: '删除配置',
  parameters: '参数列表',
  selfDefinedParameters: '自定义参数配置',
  setExpression: '生成公式',
  seDevice: '仅显示已选择设备',
  searchDeviceCodeOrName: '搜索设备编号或名称',
  sePoints: '仅显示已选择数据点',
  searchPointCodeOrName: '搜索数据点编号或名称',
  paramCode: '参数编码',
  paramName: '参数名称',
  expression: '计算公式',
  paramsSetting: '参数配置',
  fullscreenTime: '全屏时间',
  LLJParameter: "流量计参数",
  DBParameter: "电表参数",
  flowUnit: "流量单位"
}

const configuration = {
  title: '2D实时监测组态编辑',
  toggleTo: '切换至',
  associated: '关联站房',
  backgroundColor: '背景颜色',
  style: '样式',
  data: '数据',
  width: '宽度',
  height: '高度',
  scaleX: '缩放系数(X)',
  scaleY: '缩放系数(Y)',
  rotate: '旋转',
  zIndex: '层级',
  fontFamily: '字体',
  fontSize: '字体大小',
  color: '字体颜色',
  borderRadius: '圆角边框',
  backgroundColor: '背景色',
  content: '内容',
  bind: '绑定设备',
  device: '设备',
  parameter: '参数',
  warningSettingTableParameter: "参数(平均值)",
  unit: '单位',
  show: '显示',
  station: '站房',
  text: '文本',
  cp: '控制参数',
  range: '范围',
  coefficient: '系数',
  default: '默认值',
  chartsSetting: '图表配置',
  yPosition: 'Y轴位置',
  xPosition: 'X轴位置',
  max: '数据量上限',
  aggregationType: '聚合方式',
  SUM: '累计值',
  DIFF: '差值',
  term: '聚合周期',
  day: '日',
  month: '月',
  terms: '周期数',
  updateTerm: '更新周期',
  chartType: '图表类型',
  Y: 'Y轴',
  X: 'X轴',
  XFontSize: 'X字体大小',
  XFontColor: 'X字体颜色',
  YFontSize: 'Y字体大小',
  YFontColor: 'Y字体颜色',
  labelFont: '标签大小',
  labelColor: '标签颜色',
  decimals: '小数位数',
  returnOrigin: '不配置则按原数据返回',
  linear: '是否渐变',
  barColor: '柱体颜色',
  lineColor: '线条颜色',
  linearStart: '渐变起始色',
  linearEnd: '渐变截止色',
  dataRate: "数据倍率",
  pleaseCompleteForm: "请完善表单信息"
}

const history = {
  machineType: '机器型号',
  dateRange: '日期范围：',
  calculate: '计算',
  export: '导出颗粒度间隔',
  savePoints: "保存数据点组合",
  success: "保存成功",
  dataRange: "数据范围配置：",
  range: "数据范围：",
  filter: "筛选",
  exportByFilterOptions: "按过滤条件导出"
}

const maintain = {
  set: '设置',
  title: '保养数据',
  startTime: '起始时间',
  endTime: '截止时间',
  startRunningTime: '起始运行时间',
  endRunningTime: '截止运行时间'
}

const runningData = {
  title: '平均运行数据',
  year: '年',
  machineCode: '整机编号',
  model: '型号',
  company: '客户名称',
  area: '区域',
  start: '起始年月',
  end: '结束年月',
  type: '类型',
  pr: '功率段(kW)',
  month: '月',
  electricity: '电流',
  temperature: '温度',
  pressure: '压力',
  frequency: '频率',
  power: '功率',
  runTime: '运行时间'
}

const renzhen = {
  title: '保养券列表',
  fbillNo: '出库单编号',
  fDate: '单据时间',
  availableQty: '可用数',
  frealQty: '真实发货数量',
  rkQty: '退货数量',
  rkState: '退货状态',
  usedQty: '已使用数量',
  editTitle: '修改优惠券'
}

const warning = {
  title: '空压机预警类型',
  add: '添加预警类型',
  recovery: '恢复默认列表',
  hide: '批量隐藏',
  defaultTitle: '默认标题',
  hiddenTypes: '已隐藏的预警类型',
  show: '显示',
  warningTypes: '预警类型',
  noHiddenWarningType: '无隐藏的预警类型',
  confirmHide: '确认隐藏吗？',
  confirmHideContent: '点击确认隐藏预警类型',
  countTitle: '当前预警有',
  hide_o: '隐藏',
  check: '查看',
  ignoreInfo: '之前不提醒',
  ignoreForever: '永久不提醒',
  index: '序号',
  content: '内容',
  value: '预警值',
  offlineDays: '离线天数',
  saleOrg: '销售组织',
  avgPressure: '平均压力(MPa)',
  ratedPressure: '设定压力(MPa)',
  avgFrequency: '平均频率(Hz)',
  ratedFrequency: '上限频率(Hz)',
  lowerLimitFrequency: '下限频率(Hz)',
  avgTemperature: '平均温度(℃)',
  percentage_air: '气量不足率',
  createdAt: '预警时间',
  salesRole: '销售人员角色',
  serviceOrg: '售后组织',
  serviceName: '售后人员',
  serviceRole: '售后人员角色',
  avgCurrent: '平均电流(A)',
  ratedCurrent: '额定电流(A)',
  fanTemperature: '设定温度(℃)',
  ratedTemperature: '极限温度(℃)',
  percentage_heat: '高温率',
  percentage_overflowing: '过流率',
  percentage_low: '低频率',
  outputFrequency: '输出频率(Hz)',
  outputPower: '输出功率(kw)',
  inverterTemperature: '变频温度(℃)',
  conversionRatedPower: '换算后额定功率(kw)',
  ratedPower: '额定功率(kw)',
  percentage_block: '堵塞率',
  percentage_overload: '过载率',
  leaveDays: '剩余天数',
  leaveHours: '剩余小时',
  runTime: '累积运行时间(h)',
  maintainTime: '当前保养时间(h)',
  registerTime: '注册时间',
  maintainTimeSetting: '保养设置时间(h)',
  exhaustPressure: '排气压力(MPa)',
  exhaustTemperature: '排气温度(℃)',
  mainSpeed: '主机转速(%)',
  airFilterElementValue: '空滤报警值',
  airFilterElementRunTime: '空滤运行时间(h)',
  airFilterElementMaintainTime: '空滤保养时间(h)',
  inletVacuum: '进气负压(MPa)',
  duration: '持续时间(h)',
  oilDrumPressure: '油分桶压力(MPa)',
  outputCurrent: '输出电流(A)',
  oilSeparatorValue: '油分报警值',
  oilSeparatorRunTime: '油分运行时间(h)',
  oilSeparatorMaintainTime: '油分保养时间(h)',
  inletTemperature: '进气温度(℃)',
  oilInletPressure: '进油压力(MPa)',
  oilInletTemperature: '进油温度(℃)',
  temperatureValue: '高温预警值',
  oilRunTime: '润滑油运行时间(h)',
  oilMaintainTime: '润滑油保养时间(h)',
  mainFanInverterTemperature: '主风机变频温度(℃)',
  mainFanOutRate: '主风机输出频率(Hz)',
  inverterTemperatureValue: '变频温度报警值',
  motorBearingTemperature: '电机轴承温度(℃)',
  motorWindingTemperature: '电机绕组温度(℃)',
  motorBearingTemperatureValue: '电机轴承温度报警值',
  greaseRunTime: '润滑脂运行时间(h)',
  greaseMaintainTime: '润滑脂保养时间(h)',
  motorBearingRunTime: '电机轴承运行时间(h)',
  motorWindingTemperatureValue: '电机绕组温度报警值',
  lowOilInletPressureValue: '进油压力低报警值',
  oilFilterRunTime: '油滤运行时间(h)',
  oilFilterMaintainTime: '油滤保养时间(h)',
  note: '预警记录',
  record: '记录信息',
  errorNo: '故障编码',
  eelectric: '故障电流',
  etime: '故障时间',
  etemperature: '故障温度',
  ebus: '故障母线',
  efrequency: '故障频率',
  epressure: '故障压力',
  eoutputVoltage: '故障输出电压',
  eio: '故障IO状态',
  device: '设备预警',
  station: '站房预警',
  deleted: '是否消除',
  swt: '请选择预警类型',
  lastYearMaintainTime: '去年保养时间',
  lastYearRunTime: '去年运行时间',
  deletedWarning: '已消除预警列表',
  recovery: '恢复',
  confirmRecovery: '确认要恢复吗？',
  confirmText: '点击确认恢复预警',
  multiple: "多设备预警",
  avgMotorWindingTemp: "平均电机绕组温度(℃)",
  maxMotorWindingTemp: "最大电机绕组温度(℃)",
  avgEnvTemp: "平均环境温度(℃)",
  maxEnvTemp: "最大环境温度(℃)",
  lastMaintainTime: "上次保养时间",
  warningStatus: "预警状态",
  addOrder: "新增工单",
  warningOrder: "预警工单",
  deviceCode: "设备编码",
  orderLevel: "严重等级",
  orderDescription: "预警判断说明",
  handler: "处理人",
  reason: "可能原因",
  emptyLevel: "请选择严重等级",
  emptyDescription: "请输入预警判断说明",
  emptyHandler: "请选择处理人",
  emptyReason: "请选择可能原因",
  editOrder: "修改工单",
  history: "操作日志",
  operator: "操作人",
  otherWarnings: "其他预警",
  vibration: "主机振动",
  runTime: "运行时间(h)",
  maintainTime: "保养时间(h)",
  frequency: "频率(Hz)",
  vibration: "主机振动",
  setFields: "字段配置",
  noDevice: "未查询到设备信息",
  avgOilDrumPressure: "油分筒压力(MPa)"
}

const warningForm = {
  sct: '请选择约束条件',
  and: '满足以下所有条件',
  or: '满足以下任一条件',
  judgeCondition: '判断条件',
  add: '添加预警',
  delete: '删除模板',
  judge: '判断',
  value: '取值',
  content: '预警内容',
  mobile: '通知手机号',
  duration: '持续周期',
  notifyInterval: '预警频率',
  empty: '暂无预警',
  fail: '提交失败，请稍后再试',
  none: '--无--',
  template: '模板',
  st: '请选择模板',
  swmn: '请输入预警名称(不超过20个字)',
  swm: '请输入预警名称',
  DEVICE_STATUS: '离线预警',
  DEVICE_PARAMETER: '参数预警',
  strategyConstraint: '约束条件',
  encn: '请输入通知内容(不超过120个字)',
  enc: '请输入通知内容',
  noticeFrequency: '通知频率(小时)',
  snf: '请选择通知频率',
  warningLevel: '预警级别',
  swl: '请选择预警级别',
  URGENT: '紧急',
  IMPORTANT: '重要',
  MINOR: '次要',
  PROMPT: '提示',
  effectiveTime: '生效时间',
  noticeCnt: '通知次数',
  recoveryNotice: '恢复正常时通知',
  warningRepeat: '生效周期',
  swr: '请选择生效周期',
  Sunday: '周日',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  description: '预警描述',
  ed: '请输入预警描述',
  addCondition: '添加预警条件',
  undo: '撤销',
  valueType: '值类型',
  monitorTime: '监控时长',
  addMobile: '添加通知手机号',
  phoneNumber: '手机号码',
  userRole: '用户角色',
  SMSEnable: '是否接收短信',
  warningRecord: '预警记录查询',
  submitTemplate: '保存为模板',
  deviceStatus: '设备状态',
  deviceParamter: '设备参数',
  n: '最大字数不能超过',
  ORIGIN: '原始值',
  AVERAGE: '平均值',
  MAX: '最大值',
  MIN: '最小值',
  SUM: '求和值',
  minutes: '分钟',
  ealopn: '请输入至少一个通知手机号',
  offline: '离线指标',
  exitedTemplate: '同名预警模板已存在',
  ratioWarning: '气电比预警',
  noDevice: '暂无设备',
  templateId: '模板ID',
  schedule: "定时任务",
  scheduleDescription: "描述",
  cron: "cron 表达式",
  cte: "确认启用吗？",
  ctd: "确认禁用吗？",
  ce: "点击确认启用",
  cd: "点击确认禁用",
  operator: "运算符",
  setExpression: "生成表达式",
  expression: "表达式",
  so: "请选择运算符",
  sm: "请选择监控时长",
  ee: "表达式输入有误",
  gap: "执行间隔",
  int: "请输入整数"
}

const dataReport = {
  addTemplate: '新增模板',
  priority: '优先级',
  templateName: '模板名称',
  editTemplate: '编辑模板',
  deleteTemplate: '删除模板',
  day: '按日',
  week: "按周",
  month: '按月',
  year: '按年',
  calculation: '计算说明',
  exportColumns: '导出列',
  datetime: '时间',
  timeRange: "时间区间",
  avgGasConsumption: '平均用气量',
  flowMeterAccumulation: '流量计累积',
  avgPower: '小时用电量',
  electricityMeterAccumulation: '电表累积',
  avgPressure: '平均压力',
  avgConsumption: '平均单耗',
  specificPower: '比功率',
  gasElectricRatio: '老气电比',
  unitConsumption: "单耗",
  rfs: "区间流量起始值",
  rfe: "区间流量截止值",
  res: "区间用电量起始值",
  ree: "区间用电量截止值",
  comparison: "数据环比",
  compare: "对比",
  increase: "增长率",
  weekFormatter: "yyyy年第WW周",
  confirmToDeleteModel: "确认要删除模板吗？",
  clickToConfirmDelete: "点击确认删除模板",
  checkeExtremeValue: "查看最值",
  noDevice: "此站房暂无流量计和电表",
  selectTimeRange: "请选择起始时间",
  LLJ: "流量计数据点",
  DB: "电表数据点",
  points: "数据点",
  LLJDB: "流量计 + 电表",
  gasElectricRatio: "气电比",
  result: "分析结果",
  origin: "原始数据"
}

const role = {
  title: '角色列表',
  columns: {
    name: '角色名称',
    privilegeLevel: '权限等级',
    enabled: '是否启用'
  },
  copy: '复制',
  clipboard: '剪切板',
  importAuth: '导入菜单及权限'
}

const permission = {
  title: '角色与权限',
  pRole: '父级角色',
  name: '角色名称',
  dataScope: '数据权限',
  to: '本组织',
  tois: '本组织及下属',
  s: '本人',
  dt: '设备类型',
  e: '本人查询',
  userDataScope: '全部用户数据查询'
}

const menu = {
  title: '菜单列表',
  name: '菜单名称',
  isMobile: '显示环境',
  icon: '图标',
  pMenu: '父级菜单',
  enabled: '是否启用',
  type: '菜单类型',
  catalogue: '目录',
  menu: '菜单',
  route: '路径',
  alias: '路径名',
  authorities: '权限设置',
  englishName: '英文名',
  priority: '优先级'
}

const organization = {
  title: '组织列表',
  enabled: '是否启用',
  name: '组织名称',
  p: '父级组织',
  code: '组织编号'
}

const dict = {
  title: '字典列表',
  name: '字典类型名称',
  typeCode: '字典类型编码',
  'zh-CN': '字典类型名称(中)',
  'en-US': '字典类型名称(英)',
  code: '字典编码',
  addTitle: '新增字典',
  editTitle: '编辑字典',
  text: '字典名称(中)',
  en: '字典名称(英)',
  value: '字典值',
  insert: '添加字典'
}

const client = {
  title: '客户端列表',
  code: '客户端编码',
  name: '客户端名称',
  stationScope: '授权站房',
  authorities: '权限',
  stations: '站房列表',
  authorityList: '权限列表',
  stationCode: '站房编号',
  stationName: '站房名称',
  'zh-CN': '权限名称',
  authCode: '权限编码',
  addTitle: '新增客户端',
  editTitle: '编辑客户端'
}

const linkage = {
  title: '联控设备组',
  groupCode: '联控组编码',
  groupName: '联控组名称',
  enabled: '是否启用',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  basicInfo: '基本信息',
  masterDevice: '主设备列表',
  operationCode: '联控操作',
  statusCondition: '设备状态条件',
  slaveDevice: '从设备列表',
  soc: '请选择联控操作',
  ssc: '请选择设备状态条件',
  ssct: '设备状态条件选择',
  command: '指令',
  sc: '请选择指令',
  searchPoints: '搜索数据点',
  cs: '指令选择',
  empty: '无可写数据点',
  create: '生成',
  extra: '#数据点编码=写入值;',
  egn: '请输入联控组名称',
  code: '编码',
  name: '名称',
  unit: '单位',
  coefficient: '系数',
  sm: '请配置主设备',
  masterCondition: '主设备条件',
  or: '满足任一条件',
  and: '满足所有条件',
  mt: '主设备模板',
  st: '从设备模板'
}

const YSB = {
  title: '易收宝店员列表',
  name: '姓名',
  mobile: '联系方式',
  addTitle: '新增店员',
  editTitle: '编辑店员',
  JDOrganization: '金蝶组织',
  JDDepartment: '金蝶部门'
}

const param = {
  title: '参数设置',
  searchDevice: '设备查询',
  deviceCode: '查询整机编号',
  writeOrRead: '读写方式',
  write: '写入',
  read: '读取',
  number: '请输入不大于65535的数字',
  selectParam: '参数选择',
  searchParam: '查询参数',
  address: '参数地址',
  createText: '生成文本',
  command: 'AT指令',
  createContent: '生成内容',
  send: '发送',
  returnedContent: '返回内容'
}

const modification = {
  title: '设备修改次数',
  count: '修改次数',
  details: '查看详情',
  user: '修改用户',
  points: '数据点'
}

const module = {
  title: '未拆除模块',
  powerOnTime: '启动时间'
}

const devicePosition = {
  title: '设备定位历史记录',
  positionUpdatedAt: '定位更新时间',
  longitude: '经度',
  latitude: '纬度',
  showMap: '查看定位记录',
  noHistory: '该设备暂无定位变更记录',
  arriveTime: '到达时间'
}

const protocol = {
  title: '通讯协议',
  searchCodeOrName: '搜索编号或名称',
  importP: '导入协议',
  public: '公有协议',
  private: '私有协议',
  copy: '复制协议',
  name: '协议名称',
  type: '协议类型',
  retryCnt: '重试次数',
  timeout: '采集超时',
  intervalTime: '采集间隔',
  atLeastOnePro: '至少选择一条协议',
  new: '请输入新的协议编号',
  sync: '同步',
  ignoreCode: '参数标志',
  ignoreInfo: '*该参数为无忽略单条记录',
  warningTemplate: '预警模板',
  addPoint: '添加数据点',
  sum: '累积量',
  fluctuation: '波动量',
  sst: '请选择统计类型',
  sct: '请选择编码形式',
  svt: '请选择数据类型',
  spt: '请选择读写模式',
  sbo: '请选择解析方式',
  readonly: '只读',
  wirte: '写入',
  switch: '开关',
  saw: '请选择数据写入',
  sdl: '请选择数据等级',
  open: '开',
  close: '关',
  convertRules: '转换规则',
  virtualPointSetting: '虚拟数据点配置',
  addTemplate: '添加模板',
  ec: '请输入编码',
  dcs: '请勿输入特殊字符',
  cr: '数据点编码重复',
  pce: '协议编号已存在',
  syncFail: '同步失败，请稍后再试',
  virtualPoint: '仅支持虚拟数据点',
  wirteOnly: '只写',
  war: '读写',
  e: '请输入',
  cpi: '请完善数据点信息s',
  sm: '请选择匹配符',
  etv: '请输入目标值',
  esv: '请输入显示值',
  et: '请输入状态标记',
  ep: '请输入位号',
  en: '请输入名称',
  virtualPointTitle: '虚拟数据点',
  epn: '请输入协议名称',
  selectProtocolType: '请选择协议类型',
  ei: '请输入采集间隔',
  eto: '请输入采集超时',
  erc: '请输入重连次数',
  nlt20: '最大字数不能超过20',
  nlt120: '最大字数不能超过120',
  epl: '请输入单次请求最大数据点',
  name_zh: "中文名称",
  name_en: "英文名称",
  zero_zh: "0位中文",
  zero_en: "0位英文",
  one_zh: "1位中文",
  one_en: "1位英文",
  value_zh: "显示值中文",
  value_en: "显示值英文",
  match: "匹配值"
}

const resources = {
  title: '资源管理',
  upload: '上传',
  code: '编号',
  category: '分类',
  url: '地址',
  uploadTime: '上传时间',
  deleteFile: '删除文件',
  resourceCategary: '资源分类'
}

const binding = {
  KYJ: '空压机绑定',
  LGJ: '冷干机绑定',
  ordersQuery: '出库单号查询',
  dateOut: '出库日期',
  searchConditions: '查询条件',
  provideModel: '供方型号',
  customerInfo: '客户信息',
  customerName: '公司名称',
  acceptAddress: '公司地址',
  contractManager: '客户联系人',
  contractPhone: '联系方式',
  province: '省',
  city: '市',
  provincial: '区',
  serviceInfo: '售后信息',
  salesMen: '销售人员',
  ssm: '请选择销售人员',
  salesPhone: '销售电话',
  serviceMan: '服务人员',
  ssem: '请选择服务人员',
  servicePhone: '服务电话',
  regist: '注册',
  current: '当前',
  dontExit: '不存在，是否新增',
  continue: '确认继续注册吗？点击确认继续注册，点击取消返回编辑',
  orderCode: '订单编号',
  secondSale: '二次销售',
  terminalCustomer: '终端客户名称',
  saleDepartment: '销售部门',
  epr: '请输入区',
  ec: '请输入市',
  ep: '请输入省',
  eqdc: '请输入要查询的整机编号',
  confirmProtocolCode: '确认协议编号',
  diffProtocolCode: '协议编号与设定不同，设定为：',
  noDeviceInfo: '暂无相关设备信息',
  exitDevice: '存在重复编号的设备',
  diffModel: '规格型号不等于供方型号',
  dtuCodeLength: "模块编号长度小于6位，请确认模块编号是否正确",
  exitDtuCode: '请确认模块编号是否重复',
  addUserScuccess: '添加用户成功',
  updateCustomerSuccess: '更新客户成功',
  addCustomerSuccess: '新增客户成功',
  updateDevice: '更新设备成功',
  addDevice: '新增设备成功',
  hostCode: '主机编号',
  ygkCustomer: '云管控客户',
  edc: '请输入整机编号',
  asa: '请确认是否新增销售员：',
  ase: '请确认是否新增服务员：',
  osa: '，原有销售员：',
  ose: '，原有服务员：',
  resend: '重新发货',
  unRegCustomer: '未注册经销商',
  customerShortName: '客户简称',
  areaManager: '区域经理',
  shrAddress: '联系地址',
  differentDtucode: "模块编号不一致"
}

const visitRecords = {
  importSuccessfully: '导入成功',
  title: '回访记录列表',
  import: '导入',
  department: '部门',
  machineName: '整机名称',
  serviceItem: '服务内容',
  phone: '联系人手机号码',
  q1: '问题1：服务态度',
  q2: '问题2：5s满意度',
  q3: '问题3：保养后机器使用情况如何',
  q4: '问题4：推荐程度',
  totalScore: '总分',
  activityName: '活动名称',
  sy: '请选择年份',
  area: '活动区域',
  sm: '请选择月份',
  minusScoreReason: '不满分原因',
  minusScoreReasonIF: '不满分原因（包含回访不成功）',
  statisticsMonth: '月回访统计',
  team: '团队',
  totalVisits: '总回访量',
  satisfactionNum: '满意客户数',
  satisfactionRate: '满意率',
  year: '年',
  month: '月',
  analyse: '售后回访分析',
  success: '回访成功',
  ratio: '占比',
  fullScore: '满分',
  minusScore: '不满分',
  fail: '回访不成功',
  failReason: '不成功原因',
  num: '数量'
}

const report46 = {
  unaudited: '未审核',
  audited: '已审核',
  title: '46项综合维护报告列表',
  auditState: '审核状态',
  progress: '审核时填写状态',
  completeState: '当前填写状态',
  audit: '审核',
  exportTitle: '46项综合维护报告',
  file: '-文件',
  checkItem: '检查与维护项',
  range: '标准范围',
  before: '维护前',
  after: '维护后',
  starRating: '星级评价：',
  remark: '评语：',
  customerSignature: '客户签名：',
  reportCode: '单号：',
  maintenanceDate: '维护日期：',
  export: '导出'
}

const funnel = {
  industryClassification: '行业分类',
  businessType: '业务类型',
  projectName: '项目名称',
  startTime: '项目跟进起始时间',
  budgetedAmount: '预算金额',
  currentStage: '当前阶段',
  winPercent: '赢率',
  expectedOutput: '预计产值',
  contractAmount: '合同金额',
  customerLeadDepartment: '客户牵头部门',
  relevantContact: '相关联系人',
  customerStakeholders: '客户干系人',
  keyman: '关键决策人',
  demandContent: '需求内容',
  currentProgress: '当前进度',
  nextVisitTime: '下次预计拜访时间',
  competitor: '竞争友商',
  visitContent: '拜访内容',
  cooperativePartner: '协作合作方',
  determine: '判定',
  failureReason: '失败原因',
  details: '详情',
  ss: '选择项目跟进起始时间'
}

const recordDetail = {
  funnel: '销售漏斗',
  followRecord: '跟进记录',
  ordered: '已成单',
  nOrdered: '未成单',
  reportValid: '报备有效',
  reportInvalid: '报备无效',
  er: '请输入报备人',
  es: '请输入销售员',
  sa: '请选择公司地址',
  el: '请输入联系人',
  eln: '联系人电话不能为空',
  ek: '请输入决策人',
  ekn: '决策人电话不能为空',
  ecd: '请输入客户需求',
  eom: '请输入原有机型',
  eept: '请输入预计购机时间',
  sis: '请选择信息来源',
  ecb: '请输入客户归属',
  recommit: '此单已报备无效，无法重复提交',
  oldCustomerInfo: '老客户信息',
  reportedInfo: '已报备信息',
  completeForm: '请填写公司名，联系人电话，决策人电话后再查重',
  delayReason: '请填写延长原因',
  title: '报备记录详情',
  reportTime: '报备时间',
  reporter: '报备人',
  reporterOrganization: '报备人组织',
  duplicate: '查重',
  policymaker: '决策人',
  policymakerNum: '决策人电话',
  customerDemand: '客户需求',
  originalModel: '原有机型',
  customerBelong: '客户归属',
  informationSources: '信息来源',
  estimatedPurchaseTime: '预计购机时间',
  isorder: '是否成单',
  state: '报备记录状态',
  failReason: '无效原因',
  cdjx: '成单机型',
  ycyy: '延长原因',
  delete: '按 delete 键可删除',
  area: '省市区',
  province: '请选择省份',
  city: '请选择市',
  region: '请选择县或区',
  town: '请选择镇或街道',
  submit: '提 交',
  reportRecord: '报备记录',
  addFollowRecord: '添加跟进记录',
  nextVisitTime: '下次跟进时间',
  nextVisitGoal: '下次跟进目标',
  writeTime: '填写时间',
  trackSituation: '跟踪情况'
}

const calcCDL = {
  salemanName: '信息经理',
  netRate: '成单率',
  netCD: '成单数量',
  netInfoRate: '网络信息占比率%',
  netBD: '报备数量',
  faRate: '成单率%',
  faCD: '成单数量',
  faBD: '报备数量',
  factoryInfoRate: '工厂信息占比率%（售后安装）',
  selfInfoRate: '自己信息占比率%',
  infoSourceRate: '成单信息报备来源分类及占比率%',
  newRate: '新客户成单占比%',
  newCD: '新客户成单',
  newNum: '新客户',
  oldRate: '老客户成单占比%',
  oldCD: '老客户成单',
  oldNum: '老客户',
  oldNewRate: '成单信息中新老客户占比',
  totalCD: '总成单',
  totalJD: '总接单'
}

const recordsList = {
  char6: '请输入至少6个字符',
  address: '请输入详细地址',
  overdue: '已过期',
  recordTime: '根据报备时间排序',
  expirationTime: '根据报备到期时间排序',
  myReport: '我的报备',
  elseReport: '别人报备',
  empty: '未勾选任何记录',
  keyword: '关键字',
  order: '排序',
  type: '记录类型',
  add: '添加报备',
  info: '跟单信息',
  state: '状态',
  customerDemand: '报备到期时间',
  wasDue: '已到期',
  addInfo: '添加报备信息',
  eun: '请输入用户名称'
}

const SIM = {
  title: "国外卡管理",
  giccid: "卡号",
  status: "SIM卡状态",
  currentBasicServicePackageName: "基本资费方案",
  currentCycleDataUsage: "周期用量（KB）",
  activatedTime: "首次激活时间",
  sellTime: "分配时间",
  deviceCode: "整机编号",
  deviceName: "设备名称",
  model: "规格型号",
  deviceType: "设备类型",
  deviceStatus: "运行状态",
  company: "客户名称",
  organization: "归属组织",
  activate: "激活",
  deactivate: "停用",
  retire: "失效",
  cta: "确认要激活吗",
  ctd: "确认要停用吗",
  ctr: "确认要失效吗",
  createdAt: "设备创建时间",
  multiple: "该模块绑定了多张SIM卡",
  empty: "该模块未绑定SIM卡",
  powerOnTime: "首次开机时间",
  sync_dtu: "同步刷新",
  cts: "确认要同步刷新吗"
}

const time = {
  week: "一周后",
  halfMonth: "半月后",
  month: "一个月后",
  threeMonths: "三个月后",
  halfYear: "半年后",
  year: "一年后"
}

const warningOrder = {
  code: "工单编号",
  status: "工单状态",
  handlerPhoneNumber: "处理人号码",
  handleMethod: "处理方法",
  followerPhoneNumber: "跟进人号码",
  solution: "解决方案",
  estimatedTime: "预计处理时间",
  processedTime: "处理完成时间",
  handledTime: "系统处理完成时间",
  handle: "处理",
  finish: "完成处理",
  comment: "评论",
  enterEstimatedTime: "请选择预计处理时间",
  resolvable: "是否无法处理",
  live: "现场情况",
  handledDetails: "处理详情",
  noComments: "暂无评论",
  enterComment: "请输入评论内容",
  reply: "回复",
  confirmToDelete: "确认要删除评论吗",
  confirm: "点击确认删除评论",
  ctdo: "确认要删除工单吗",
  selectHandleMethod: "请选择处理方法",
  orderDetail: "工单详情",
  orderInfo: "工单信息",
  noReasons: "暂无可能原因",
  saveFirst: "尚有未保存的原因，请先保存",
  noHandleMethods: "暂无处理方法",
  confirmToDeleteReason: "确认要删除该可能原因吗？",
  confirmToDeleteHandleMethod: "确认要删除该处理方法吗？",
  confirmReason: "点击确认删除可能原因",
  confirmHandleMethod: "点击确认删除处理方法",
  reasonSetting: "可能原因配置",
  methodSetting: "处理方法配置"
}

const deviceWarningsCount = {
  title: "设备预警统计"
}

const warningHistory = {
  title: "预警历史"
}

export default {
  documentTitle: '德曼节能空压机数据平台',
  tagsClose: '关闭以下标签',
  common,
  messages,
  buttons,
  login,
  overview,
  user,
  customer,
  placeholder,
  device,
  orders,
  saleDocument,
  station,
  configuration,
  history,
  maintain,
  runningData,
  renzhen,
  warning,
  dataReport,
  statistics: '实时数据',
  warn: '预警设置',
  tableS: '表格配置',
  confirm: '确认删除',
  line: '折线图',
  bar: '柱状图',
  min: '最小值：',
  max: '最大值：',
  sa: '全选',
  role,
  permission,
  menu,
  organization,
  linkage,
  dict,
  client,
  YSB,
  param,
  modification,
  module,
  devicePosition,
  warningForm,
  protocol,
  resources,
  binding,
  order_operators,
  visitRecords,
  report46,
  funnel,
  recordDetail,
  calcCDL,
  recordsList,
  region,
  SIM,
  time,
  warningOrder,
  deviceWarningsCount,
  warningHistory
}
